<template>
  <global-dialog-card
    v-model="model"
    :title="`${translate(food.name)} ${$t('qr_code')}`"
    :subtitle="`ID: ${food.id}`"
    hide-actions
    :max-width="500"
  >
    <v-row justify="center" class="pt-5">
      <div v-if="loading" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <div class="mt-3">{{ $t('generating_qr_code') }}</div>
      </div>
      <vue-qrcode
        v-else-if="selectedQrSecret"
        :value="
          JSON.stringify({
            id: this.selectedQr,
            secure: this.selectedQrSecret,
          })
        "
        :options="{ width: 200 }"
        style="border: 2px solid gray"
      ></vue-qrcode>
      <div v-else class="text-center">
        <v-icon size="64" color="grey lighten-1">mdi-qrcode-remove</v-icon>
        <div class="mt-3 grey--text">{{ $t('error_generating_qr') }}</div>
      </div>
    </v-row>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import userService from "@/services/user";

export default {
  name: "FoodQrDialog",
  mixins: [hasModel, hasSnackbar],
  components: {
    VueQrcode,
  },
  props: {
    food: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedQrSecret: false,
      selectedQr: false,
      loading: false,
    };
  },
  methods: {
    getQr() {
      this.loading = true;
      this.selectedQrSecret = false;
      this.selectedQr = false;
      
      userService
        .getUserHash(this.food.id)
        .then((res) => {
          this.selectedQrSecret = res.data;
          this.selectedQr = this.food.id;
        })
        .catch((error) => {
          console.error("Error generating QR:", error);
          this.showErrorSnackbar(this.$t('error_generating_qr_code'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    model(newVal) {
      if (newVal) {
        this.getQr();
      }
    },
  },
};
</script>
